import cn from 'classnames'
import React, { ComponentProps } from 'react'

export type DecliningBalanceFlyoutSvgProps = ComponentProps<'svg'>

export default function DecliningBalanceFlyoutSvg(
  props: DecliningBalanceFlyoutSvgProps,
) {
  const { className = '', ...rest } = props
  return (
    <svg
      className={cn('DecliningBalanceFlyoutSvg', className)}
      width="118"
      height="102"
      viewBox="0 0 118 102"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...rest}
    >
      <g clipPath="url(#clip0_22752_69125)">
        <g filter="url(#filter0_d_22752_69125)">
          <path
            d="M59 98C84.9574 98 106 76.9574 106 51C106 25.0426 84.9574 4 59 4C33.0426 4 12 25.0426 12 51C12 76.9574 33.0426 98 59 98Z"
            fill="black"
          />
        </g>
        <path
          d="M59 98C84.9574 98 106 76.9574 106 51C106 25.0426 84.9574 4 59 4C33.0426 4 12 25.0426 12 51C12 76.9574 33.0426 98 59 98Z"
          fill="#F2F3F7"
        />
        <path
          d="M86.1744 3.19927L4.20891 43.1765C2.02354 44.2424 1.11601 46.878 2.18189 49.0634L25.9394 97.7735C27.0053 99.9589 29.6409 100.866 31.8263 99.8005L113.792 59.8233C115.977 58.7574 116.885 56.1218 115.819 53.9364L92.0613 5.22628C90.9954 3.04092 88.3598 2.13339 86.1744 3.19927Z"
          fill="#21BA99"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M72.5391 42.4129L21.9284 67.0973C21.3901 67.3599 21.1666 68.009 21.4291 68.5473L22.1061 69.9353C22.3686 70.4736 23.0178 70.6971 23.5561 70.4346L74.1668 45.7501C74.705 45.4876 74.9286 44.8384 74.666 44.3002L73.989 42.9121C73.7265 42.3739 73.0773 42.1503 72.5391 42.4129Z"
          fill="url(#paint0_linear_22752_69125)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M91.0039 45.5574L26.7159 76.9127C26.1777 77.1753 25.9541 77.8244 26.2167 78.3627L26.8937 79.7507C27.1562 80.289 27.8054 80.5125 28.3436 80.25L92.6316 48.8947C93.1699 48.6321 93.3934 47.983 93.1309 47.4447L92.4539 46.0566C92.1913 45.5184 91.5422 45.2949 91.0039 45.5574Z"
          fill="url(#paint1_linear_22752_69125)"
        />
        <path
          opacity="0.5"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M50.8516 77.2918L31.5033 86.7285C30.965 86.9911 30.7415 87.6402 31.004 88.1785L31.681 89.5666C31.9435 90.1048 32.5927 90.3284 33.131 90.0658L52.4793 80.629C53.0175 80.3665 53.241 79.7173 52.9785 79.1791L52.3015 77.791C52.039 77.2528 51.3898 77.0292 50.8516 77.2918Z"
          fill="url(#paint2_linear_22752_69125)"
        />
        <path
          opacity="0.5"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M85.0449 60.615L65.6966 70.0518C65.1584 70.3143 64.9348 70.9635 65.1974 71.5018L65.8744 72.8898C66.1369 73.4281 66.7861 73.6516 67.3243 73.3891L86.6726 63.9523C87.2109 63.6898 87.4344 63.0406 87.1719 62.5023L86.4949 61.1143C86.2324 60.576 85.5832 60.3525 85.0449 60.615Z"
          fill="url(#paint3_linear_22752_69125)"
        />
        <path
          d="M79.696 23.008C79.8525 22.5535 80.3478 22.3119 80.8023 22.4684L85.1937 23.9805C85.7159 24.1603 86.285 23.8828 86.4648 23.3606L87.9769 18.9691C88.1334 18.5146 88.6287 18.273 89.0832 18.4295C89.5377 18.586 89.7792 19.0813 89.6227 19.5358L87.5439 25.5731C87.3641 26.0953 86.795 26.3729 86.2728 26.1931L80.2355 24.1143C79.7811 23.9578 79.5395 23.4625 79.696 23.008Z"
          fill="white"
        />
        <path
          d="M77.2145 17.923C77.371 17.4685 77.8663 17.2269 78.3208 17.3834L82.7123 18.8955C83.2344 19.0753 83.8035 18.7978 83.9833 18.2756L85.4954 13.8841C85.6519 13.4296 86.1472 13.1881 86.6017 13.3446C87.0562 13.5011 87.2978 13.9964 87.1413 14.4508L85.0625 20.4882C84.8827 21.0104 84.3136 21.2879 83.7914 21.1081L77.7541 19.0293C77.2996 18.8728 77.058 18.3775 77.2145 17.923Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_22752_69125"
          x="7"
          y="1"
          width="104"
          height="104"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_22752_69125"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_22752_69125"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_22752_69125"
          x1="61.0906"
          y1="50.0622"
          x2="33.046"
          y2="63.7405"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E4FFF9" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_22752_69125"
          x1="76.1109"
          y1="54.8868"
          x2="40.7685"
          y2="72.1244"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E4FFF9" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_22752_69125"
          x1="47.2764"
          y1="81.1011"
          x2="35.9126"
          y2="86.6436"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E4FFF9" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_22752_69125"
          x1="81.4697"
          y1="64.4243"
          x2="70.1059"
          y2="69.9668"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E4FFF9" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <clipPath id="clip0_22752_69125">
          <rect width="118" height="102" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
